import { axiosInstance } from 'src/boot/axios';

export function saveMedicalTreatment({ commit }, payload) {
  const formData = new FormData();
  formData.set('CurrentSelectedCustomerNumber', payload.selectedCustomerNumber);
  formData.set('Indication', payload.indication);
  formData.set('TreatmentDone', payload.treatmentDone);
  formData.set('HasMedication', payload.medication.hasMedication?.key === 'yes');
  if (payload.medication.hasMedication?.key === 'yes') {
    formData.set('WhichMedication', payload.medication.whichMedication);
  }
  formData.set('Necessary', payload.necessary);
  formData.set('Reference', payload.docsAvailable.reference?.key === 'yes');
  formData.set('TreatmentPlan', payload.docsAvailable.treatmentPlan?.key === 'yes');
  formData.set('Offer', payload.docsAvailable.offer?.key === 'yes');
  formData.set('TreatmentDateKnown', payload.dateKnown?.key === 'yes');
  if (payload.dateKnown?.key === 'yes') {
    formData.set('TreatmentDate', payload.date);
  }
  formData.set('InstanceAbroad.InstanceName', payload.instanceAbroad.instanceName);
  formData.set('InstanceAbroad.Address.Street', payload.instanceAbroad.street);
  formData.set('InstanceAbroad.Address.PostalCode', payload.instanceAbroad.postalCode);
  formData.set('InstanceAbroad.Address.HouseNumber', payload.instanceAbroad.houseNumber);
  formData.set('InstanceAbroad.Address.City', payload.instanceAbroad.city);
  formData.set('InstanceAbroad.Address.CountryCode', payload.instanceAbroad.country.key);
  formData.set(
    'InstanceAbroad.PhoneNumber',
    payload.instanceAbroad.phoneNumber.prefix.value + payload.instanceAbroad.phoneNumber.number,
  );
  formData.set('InstanceAbroad.Email', payload.instanceAbroad.email);

  if (payload.additionalInformation) {
    formData.set('AdditionalInformation', payload.additionalInformation);
  }

  payload.documents.forEach((file) => formData.append('Files', file.file));

  commit('setIsSavingTreatmentAbroad', true);

  return axiosInstance.post('TreatmentAbroad/MedicalTreatment', formData).finally(() => {
    commit('setIsSavingTreatmentAbroad', false);
  });
}

export function saveFertilityTreatment({ commit }, payload) {
  const formData = new FormData();

  formData.set('CurrentSelectedCustomerNumber', payload.selectedCustomerNumber);
  formData.set('TreatmentDate', payload.treatmentDate);
  formData.set('Offer', payload.docsAvailable.offer?.key === 'yes');
  formData.set('Reference', payload.docsAvailable.reference?.key === 'yes');
  formData.set('TreatmentPlan', payload.docsAvailable.treatmentPlan?.key === 'yes');
  formData.set('InstanceAbroad.InstanceName', payload.instanceAbroad.instanceName);
  formData.set('InstanceAbroad.PractitionerName', payload.instanceAbroad.practitionerName);
  formData.set('InstanceAbroad.Address.Street', payload.instanceAbroad.street);
  formData.set('InstanceAbroad.Address.PostalCode', payload.instanceAbroad.postalCode);
  formData.set('InstanceAbroad.Address.HouseNumber', payload.instanceAbroad.houseNumber);
  formData.set('InstanceAbroad.Address.City', payload.instanceAbroad.city);
  formData.set('InstanceAbroad.Address.CountryCode', payload.instanceAbroad.country.key);
  formData.set(
    'InstanceAbroad.PhoneNumber',
    payload.instanceAbroad.phoneNumber.prefix.value + payload.instanceAbroad.phoneNumber.number,
  );
  formData.set('InstanceAbroad.Email', payload.instanceAbroad.email);
  formData.set('Necessary', payload.necessary);
  formData.set('TreatmentType', payload.treatmentType?.key);
  if (payload.treatmentType?.name === 'ivf-icsi') {
    payload.ivfIcsiTreatments.forEach((treatment) => formData.append('IvfIcsiTreatmentType', treatment.key));
  }
  formData.set('PartiallyNetherlands', payload.partiallyNetherlands?.key === 'yes');
  if (payload.partiallyNetherlands?.key === 'yes') {
    formData.set('InstanceNetherlands.InstanceName', payload.instanceNetherlands.instanceName);
    formData.set('InstanceNetherlands.PractitionerName', payload.instanceNetherlands.practitionerName);
    formData.set('InstanceNetherlands.Address.Street', payload.instanceNetherlands.street);
    formData.set('InstanceNetherlands.Address.PostalCode', payload.instanceNetherlands.postalCode);
    formData.set('InstanceNetherlands.Address.HouseNumber', payload.instanceNetherlands.houseNumber ?? 0);
    formData.set('InstanceNetherlands.Address.City', payload.instanceNetherlands.city);
    formData.set('InstanceNetherlands.Address.CountryCode', 'NL');
    formData.set(
      'InstanceNetherlands.PhoneNumber',
      payload.instanceAbroad.phoneNumber.prefix.value + payload.instanceAbroad.phoneNumber.number,
    );
    formData.set('InstanceNetherlands.Email', payload.instanceNetherlands.email);
  }

  payload.documents.forEach((file) => formData.append('Files', file.file));

  if (payload.additionalInformation) {
    formData.set('AdditionalInformation', payload.additionalInformation);
  }

  commit('setIsSavingTreatmentAbroad', true);

  return axiosInstance.post('TreatmentAbroad/FertilityTreatment', formData).finally(() => {
    commit('setIsSavingTreatmentAbroad', false);
  });
}

export function saveNursingAndCare({ commit }, payload) {
  const formData = new FormData();

  formData.set('CurrentSelectedCustomerNumber', payload.selectedCustomerNumber);
  formData.set('Indication', payload.indication?.key === 'yes');
  formData.set('NursingTime.Hours', payload.time.nursing.hours ?? 0);
  formData.set('NursingTime.Minutes', payload.time.nursing.minutes ?? 0);
  formData.set('PersonalCareTime.Hours', payload.time.personalCare.hours ?? 0);
  formData.set('PersonalCareTime.Minutes', payload.time.personalCare.minutes ?? 0);
  formData.set('StartDate', payload.duration.from);
  formData.set('EndDate', payload.duration.to);

  formData.set('DutchNurseKnown', payload.dutchNurse.known?.key === 'yes');
  if (payload.dutchNurse.known?.key === 'yes') {
    formData.set('DutchNurse.Name', payload.dutchNurse.details.name);
    formData.set(
      'DutchNurse.PhoneNumber',
      payload.dutchNurse.details.phoneNumber?.prefix?.value + payload.dutchNurse.details.phoneNumber?.number,
    );
    formData.set('DutchNurse.BigNumber', `${payload.dutchNurse.details.bigNumber}`);
    formData.set('DutchNurse.Level', payload.dutchNurse.details.level);
    formData.set('DutchNurse.CareInstanceName', payload.dutchNurse.details.careInstanceName);
    formData.set('DutchNurse.AgbCode', `${payload.dutchNurse.details.agbCode}`);
  }

  formData.set('InstanceAbroad.InstanceName', payload.instanceAbroad.instanceName);
  formData.set('InstanceAbroad.Address.Street', payload.instanceAbroad.street);
  formData.set('InstanceAbroad.Address.PostalCode', payload.instanceAbroad.postalCode);
  formData.set('InstanceAbroad.Address.HouseNumber', payload.instanceAbroad.houseNumber);
  formData.set('InstanceAbroad.Address.City', payload.instanceAbroad.city);
  formData.set('InstanceAbroad.Address.CountryCode', payload.instanceAbroad.country.key);
  formData.set(
    'InstanceAbroad.PhoneNumber',
    payload.instanceAbroad.phoneNumber.prefix.value + payload.instanceAbroad.phoneNumber.number,
  );
  formData.set('InstanceAbroad.Email', payload.instanceAbroad.email);

  if (payload.additionalInformation) {
    formData.set('AdditionalInformation', payload.additionalInformation);
  }

  payload.documents.forEach((file) => formData.append('Files', file.file));

  commit('setIsSavingTreatmentAbroad', true);

  return axiosInstance.post('TreatmentAbroad/NursingAndCare', formData).finally(() => {
    commit('setIsSavingTreatmentAbroad', false);
  });
}

export function saveMentalHealth({ commit }, payload) {
  const formData = new FormData();
  formData.set('CurrentSelectedCustomerNumber', payload.selectedCustomerNumber);
  formData.set('Reference', payload.docsAvailable.reference?.key === 'yes');
  formData.set('TreatmentPlan', payload.docsAvailable.treatmentPlan?.key === 'yes');
  formData.set('Offer', payload.docsAvailable.offer?.key === 'yes');
  formData.set('DoctorAbroad.PractitionerName', payload.doctorAbroad.name);
  formData.set('DoctorAbroad.Profession', payload.doctorAbroad.profession);
  formData.set('DoctorAbroad.Address.Street', payload.doctorAbroad.street);
  formData.set('DoctorAbroad.Address.PostalCode', payload.doctorAbroad.postalCode);
  formData.set('DoctorAbroad.Address.HouseNumber', payload.doctorAbroad.houseNumber);
  formData.set('DoctorAbroad.Address.City', payload.doctorAbroad.city);
  formData.set('DoctorAbroad.Address.CountryCode', 'NL');
  formData.set(
    'DoctorAbroad.PhoneNumber',
    payload.doctorAbroad.phoneNumber.prefix.value + payload.doctorAbroad.phoneNumber.number,
  );

  formData.set('InstanceAbroad.InstanceName', payload.instanceAbroad.instanceName);
  formData.set('InstanceAbroad.PractitionerName', payload.instanceAbroad.practitionerName);
  formData.set('InstanceAbroad.Address.Street', payload.instanceAbroad.street);
  formData.set('InstanceAbroad.Address.PostalCode', payload.instanceAbroad.postalCode);
  formData.set('InstanceAbroad.Address.HouseNumber', payload.instanceAbroad.houseNumber);
  formData.set('InstanceAbroad.Address.City', payload.instanceAbroad.city);
  formData.set('InstanceAbroad.Address.CountryCode', payload.instanceAbroad.country.key);
  formData.set(
    'InstanceAbroad.PhoneNumber',
    payload.instanceAbroad.phoneNumber.prefix.value + payload.instanceAbroad.phoneNumber.number,
  );
  formData.set('InstanceAbroad.Email', payload.instanceAbroad.email);
  payload.documents.forEach((file) => formData.append('Files', file.file));

  if (payload.additionalInformation) {
    formData.set('AdditionalInformation', payload.additionalInformation);
  }
  formData.set('Necessary', payload.necessary);

  commit('setIsSavingTreatmentAbroad', true);

  return axiosInstance.post('TreatmentAbroad/MentalHealth', formData).finally(() => {
    commit('setIsSavingTreatmentAbroad', false);
  });
}

export function saveKidneyDialysis({ commit }, payload) {
  const formData = new FormData();
  formData.set('CurrentSelectedCustomerNumber', payload.selectedCustomerNumber);

  formData.set('InstanceAbroad.InstanceName', payload.treatmentInstance.instanceName);
  formData.set('InstanceAbroad.Address.Street', payload.treatmentInstance.street);
  formData.set('InstanceAbroad.Address.HouseNumber', payload.treatmentInstance.houseNumber);
  formData.set('InstanceAbroad.Address.PostalCode', payload.treatmentInstance.postalCode);
  formData.set('InstanceAbroad.Address.City', payload.treatmentInstance.city);
  formData.set('InstanceAbroad.Address.CountryCode', payload.treatmentInstance.country.key);
  formData.set(
    'InstanceAbroad.PhoneNumber',
    payload.treatmentInstance.phoneNumber.prefix.value + payload.treatmentInstance.phoneNumber.number,
  );
  formData.set('InstanceAbroad.Email', payload.treatmentInstance.email);
  formData.set('StartDate', payload.duration.startDate);
  formData.set('EndDate', payload.duration.endDate);
  formData.set('NeedsTransport', payload.transport.necessary?.key === 'yes');

  if (payload.transport.necessary?.key === 'yes') {
    formData.set('Residence.Street', payload.transport.residence.street);
    formData.set('Residence.PostalCode', payload.transport.residence.postalCode);
    formData.set('Residence.HouseNumber', payload.transport.residence.houseNumber);
    formData.set('Residence.City', payload.transport.residence.city);
    formData.set('Residence.CountryCode', payload.transport.residence.country.key);
  }

  formData.set('NumberOfDialysis', payload.howOften);
  formData.set('Approval', payload.approval?.key === 'yes');
  formData.set('PriceMentioned', payload.price.mentioned?.key === 'yes');
  if (payload.price.mentioned?.key === 'yes') {
    formData.set('Amount', payload.price.amount);
  }
  if (payload.additionalInformation) {
    formData.set('AdditionalInformation', payload.additionalInformation);
  }

  commit('setIsSavingTreatmentAbroad', true);

  return axiosInstance.post('TreatmentAbroad/KidneyDialysis', formData).finally(() => {
    commit('setIsSavingTreatmentAbroad', false);
  });
}
